import { CloseCircleFilled, SearchOutlined } from "@ant-design/icons";
import { InputBase } from "@mui/material";
import React, { useState } from "react";
import "./InvoiceFlightSearch.css";

const InvoiceFlightSearch = ({ setIsSearching }) => {
  const [searchFlightData, setSearchFlightData] = useState("");

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchFlightData(value);

    if (value.length === 0) {
      setIsSearching("");
    } else {
      setIsSearching(value);
    }
  };

  const handleSearchClear = () => {
    setSearchFlightData("");
    setIsSearching("");
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setIsSearching(searchFlightData);
  };

  return (
    <div className="invoice-flight-search">
      <h4>Search</h4>
      <div className="invoice-flight-search-container">
        <form
          className="invoice-flight-search-form"
          onSubmit={handleSearchSubmit}
        >
          <div className="invoice-flight-search-input-container">
            <SearchOutlined className="invoice-flight-input-icon" />
            <InputBase
              className="invoice-flight-input-style"
              placeholder="Search flight number"
              value={searchFlightData}
              onChange={handleSearchChange}
              inputProps={{ maxLength: 15 }}
            />
            {searchFlightData.length > 0 && (
              <CloseCircleFilled
                className="invoice-flight-input-icon"
                onClick={handleSearchClear}
              />
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default InvoiceFlightSearch;
